import React, { Component } from 'react';

import Typography from '@material-ui/core/Typography';
import {
  Link, withRouter
} from "react-router-dom";
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Banner from './../../PagesComponents/GeneralComponents/Banner/Banner';

import Container from '@material-ui/core/Container';

import Header from './../../PagesComponents/Headers/Header';
import Footer from './../../PagesComponents/Footer/Footer';

import Note01 from './../../PagesComponents/Notes/01Note/Note01';
import Note02 from './../../PagesComponents/Notes/02Note/Note02';
import Dynamic from './../../PagesComponents/Notes/Dynamic/Dynamic';

import './Note.scss';

class Note extends Component {

  state = {
    idBlog: null 
  };


  componentDidMount() {
    this.setState({
      idBlog: this.props.match.params.idBlog
    });
    this.getNote(this.props.match.params.idBlog);
  }

  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      this.getNote(this.props.match.params.idBlog);
    }
  }

  getNote(idBlog) {
    fetch(`${global.config.URL.SERVER}/postsByUrl/${idBlog}`, { 
      method: 'GET',
      headers: {
        'content-type': 'application/json'
      }
    })
    .then(response => response.json())
    .then(data => {
      console.log(data);
      if (data) {
        this.setState({
          post: data
        });
      }
    })
    .catch( err => {
      console.log(err);
    });
  }

  render() {
    return (
      <div className="blog-note-component">
        {/* <div className={`loadView ${(this.state.loadView) ? 'show' : ''}`}></div> */}
        <Header/>

        {(((this.props.match.params.idBlog === 'HOME-OFFICE-NUESTRA-NUEVA-NORMALIDAD') && (
          <div>
            <Banner inner={
              <Breadcrumbs aria-label="breadcrumb">
                <Link color="inherit" to="/">
                  Inicio
                </Link>
                <Link color="inherit" to="/blog">
                  Blog
                </Link>
              </Breadcrumbs>
              }
              name = {'HOME OFFICE: NUESTRA NUEVA NORMALIDAD'}
              bannerImage = {'categoria/blog.jpg'}
            />
            <Container maxWidth="md" className="mb-10">
              <Note01/>
            </Container>
          </div>
        )) ||
        ((this.props.match.params.idBlog === 'DIA-DE-LA-TIERRA') && (
          <div>
            <Banner inner={
              <Breadcrumbs aria-label="breadcrumb">
                <Link color="inherit" to="/">
                  Inicio
                </Link>
                <Link color="inherit" to="/blog">
                  Blog
                </Link>
              </Breadcrumbs>
              }
              bannerImage = {'categoria/blog.jpg'}
            />
            <Container maxWidth="md" className="mb-10">
              <Note02/>
            </Container>
          </div>
        )) ||
        (( this.state.post && this.state.post.title) && (
          <div>
            <Banner inner={
              <Breadcrumbs aria-label="breadcrumb">
                <Link color="inherit" to="/">
                  Inicio
                </Link>
                <Link color="inherit" to="/blog">
                  Blog
                </Link>
              </Breadcrumbs>
              }
              name = {this.state.post.title}
              bannerImage = {'categoria/blog.jpg'}
            />
            <Container maxWidth="md" className="mb-10">
              <Dynamic
                post={this.state.post}/>
            </Container>
          </div>
        )))}
        <Footer/>
      </div>
    );
  }
}

export default withRouter(Note);